import { makeStyles } from '@material-ui/styles';

export const makeWrapperStyles = makeStyles({
  wrapper: {
    margin: 'auto',
    maxWidth: '1365px',
    overflow: 'hidden',
  },
});
